import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import IconButton from '@material-ui/core/IconButton';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import CloudDownload from '@material-ui/icons/CloudDownload';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import Snackbar from '@material-ui/core/Snackbar';
import Modal from '@material-ui/core/Modal';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import CircularProgress from '@material-ui/core/CircularProgress';
import InputAdornment from '@material-ui/core/InputAdornment';
import clsx from 'clsx';
import { instanceAxios } from '../../InstanceAxios';
import { MSG_ERRO, XMEI_PRIMARY_COLOR } from '../../consts/common';

const useStyles = makeStyles((theme) => ({
  root: {
    overflow: 'hidden',
    width: '95%',
  },
  paper: {
    position: 'absolute',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    top: `50%`,
    left: `50%`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    transform: `translate(-50%, -50%)`,
    width: '80%',
    height: '80%',
    overflow: 'auto',
  },
  loading: {
    marginLeft: '50%',
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
}));

function Faturamento() {
  const classes = useStyles();
  const [ready, setReady] = useState(false);
  const [planilhas, setPlanilhas] = useState([]);
  const [alert, setAlert] = useState(false);
  const [alertType, setAlertType] = useState('');
  const [message, setMessage] = useState('');
  const [columns, setColumns] = useState([
    { id: 'nome', label: 'Nome', minWidth: 140 },
    { id: 'descricao', label: 'Descrção', minWidth: 140 },
    { id: 'gerar', label: 'Gerar', minWidth: 70 },
    { id: 'editar', label: 'Editar', minWidth: 70 },
    { id: 'excluir', label: 'Excluir', minWidth: 70 },
  ]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [busca, setBusca] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const [openModalParams, setOpenModalParams] = useState(false);
  const [id, setId] = useState(null);
  const [nome, setNome] = useState('');
  const [descricao, setDescricao] = useState('');
  const [sql, setSql] = useState('');
  const [has_params, setHasParams] = useState(false);
  const [labelParams, setLabelParams] = useState([]);
  const [params, setParams] = useState([]);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    fetchPlanilhas(page, limit, busca);
  }, []);

  const clickAlert = () => {
    setAlert(false);
    setAlertType('');
    setMessage('');
  };

  const fetchPlanilhas = async (p, l, b) => {
    setReady(false);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(`/planilhas?busca=${b}&limit=${l}&page=${p}`)
      .then((res) => {
        setPlanilhas(res.data.rows);
        setCount(res.data.count);
        setReady(true);
      })
      .catch((err) => {
        console.log(err);
        const msg = err.data ? err.data.message : MSG_ERRO;
        setMessage(msg);
        setAlertType('error');
        setAlert(true);
        setReady(true);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchPlanilhas(newPage, limit, busca);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setLimit(event.target.value);
    fetchPlanilhas(page, event.target.value, busca);
  };

  const handleBusca = (event) => {
    setBusca(event.target.value);
    setPage(0);
    setLimit(10);
    fetchPlanilhas(0, 10, event.target.value);
  };

  const gerarPlanilha = async (id, body = {}) => {
    setMessage('Planilha sendo gerada,aguarde!');
    setAlertType('warning');
    setAlert(true);
    setReady(false);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .post(`/gerarplanilhas/${id}`, body)
      .then((res) => {
        window.open(res.data.arquivo, '_blank');
        setAlert(false);
        setReady(true);
      })
      .catch((err) => {
        const msg = err.data ? err.data.message : MSG_ERRO;
        setMessage(msg);
        setAlertType('error');
        setAlert(true);
        setReady(true);
      });
  };

  const handleSave = async () => {
    await instanceAxios(localStorage.getItem('toobiauth'))
      .post(`/planilhas`, {
        id,
        nome,
        descricao,
        sql,
        has_params,
      })
      .then((res) => {
        updateObjPlanilha();
        fetchPlanilhas(page, limit, busca);
        setOpenModal(false);
      })
      .catch((err) => {
        const msg = err.data ? err.data.message : MSG_ERRO;
        setMessage(msg);
        setAlertType('error');
        setAlert(true);
        setReady(true);
      });
  };

  const handleDelete = async (id) => {
    await instanceAxios(localStorage.getItem('toobiauth'))
      .delete(`/planilhas/${id}`)
      .then((res) => {
        fetchPlanilhas(page, limit, busca);
      })
      .catch((err) => {
        const msg = err.data ? err.data.message : MSG_ERRO;
        setMessage(msg);
        setAlertType('error');
        setAlert(true);
        setReady(true);
      });
  };

  const updateObjPlanilha = (p = null) => {
    setId(p ? p.id : null);
    setNome(p ? p.nome : '');
    setDescricao(p ? p.descricao : '');
    setSql(p ? p.sql : '');
    setHasParams(p ? p.has_params : false);
  };

  const handleModal = (p = null) => {
    updateObjPlanilha(p);
    setOpenModal(!openModal);
  };

  const handleGerarPlanilha = (p) => {
    if (p.has_params) {
      const lbl = p.sql
        .split(' ')
        .filter((t) => t[0] === ':')
        .map((t) => t.substr(1));
      setLabelParams(lbl);
      setParams([].fill(''));
      setOpenModalParams(true);
      setId(p.id);
    } else {
      gerarPlanilha(p.id);
    }
  };

  const handleParamsSave = () => {
    const body = {};
    for (const [i, v] of labelParams.entries()) {
      body[v] = params[i];
    }
    setOpenModalParams(false);
    setParams([]);
    setLabelParams([]);
    gerarPlanilha(id, body);
  };

  return (
    <>
      <Snackbar open={alert} autoHideDuration={6000} onClose={clickAlert}>
        <Alert variant="filled" severity={alertType} onClick={clickAlert}>
          {message}
        </Alert>
      </Snackbar>
      <Paper>
        <Collapse in={ready}>
          <Grid
            container
            style={{ paddingLeft: 10, paddingRight: 10, paddingTop: '1%' }}
          >
            <Grid item xs={12}>
              <div align="center">
                <h1>Planilhas</h1>
              </div>
            </Grid>
            <Grid container>
              <Grid item xs={6}>
                <div align="left">
                  <Button
                    variant="contained"
                    startIcon={<AddCircleIcon />}
                    style={{
                      backgroundColor: XMEI_PRIMARY_COLOR,
                      color: '#FFF',
                    }}
                    size="large"
                    onClick={() => handleModal()}
                  >
                    Novo
                  </Button>
                </div>
              </Grid>
              <Grid item xs={6}>
                <div align="right">
                  <FormControl variant="outlined">
                    <TextField
                      id="busca"
                      label="Busca"
                      value={busca}
                      onChange={handleBusca}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </FormControl>
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align="center"
                    style={{ minWidth: column.minWidth, fontWeight: 'bold' }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {planilhas.map((p) => (
                <TableRow key={p.id}>
                  <TableCell component="th" scope="row" align="center">
                    {p.nome}
                  </TableCell>
                  <TableCell component="th" scope="row" align="center">
                    {p.descricao.lenght > 20
                      ? `${p.descricao.substr(0, 20)}...`
                      : p.descricao}
                  </TableCell>
                  <TableCell component="th" scope="row" align="center">
                    <IconButton onClick={() => handleGerarPlanilha(p)}>
                      <CloudDownload />
                    </IconButton>
                  </TableCell>
                  <TableCell component="th" scope="row" align="center">
                    <IconButton onClick={() => handleModal(p)}>
                      <EditIcon />
                    </IconButton>
                  </TableCell>
                  <TableCell component="th" scope="row" align="center">
                    <IconButton onClick={() => handleDelete(p.id)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TableFooter>
            <TableRow>
              <TablePagination
                component="div"
                style={{ backgroundColor: '#FFF' }}
                rowsPerPageOptions={[10, 15, 25]}
                count={count}
                rowsPerPage={limit}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                labelRowsPerPage="Linhas por página"
              />
            </TableRow>
          </TableFooter>
        </Collapse>
        <Collapse in={ready === false}>
          <CircularProgress className={classes.loading} />
        </Collapse>
      </Paper>

      <Modal className={classes.modal} open={openModal} onClose={handleModal}>
        <Grid container spacing={1} className={classes.paper}>
          <Grid item xs={12}>
            <h2>Dados da Planilha</h2>
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              id="nome"
              label="Nome"
              variant="outlined"
              value={nome}
              onChange={(event) => setNome(event.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              id="descricao"
              label="Descrição"
              variant="outlined"
              multiline
              rowsMax="5"
              value={descricao}
              onChange={(event) => setDescricao(event.target.value)}
            />
          </Grid>
          <Divider />
          <Grid item xs={12}>
            <div align="right">
              <IconButton
                className={clsx(classes.expand, {
                  [classes.expandOpen]: expanded,
                })}
                onClick={() => setExpanded(!expanded)}
                aria-expanded={expanded}
                aria-label="show more"
              >
                <ExpandMoreIcon />
              </IconButton>
            </div>
          </Grid>
          <Divider />
          <Grid item xs={12}>
            <Collapse in={expanded}>
              <TextField
                fullWidth
                id="sql"
                label="SQL"
                variant="outlined"
                multiline
                rows={5}
                value={sql}
                onChange={(event) => setSql(event.target.value)}
              />
            </Collapse>
          </Grid>
          <Grid item xs={6}>
            <Collapse in={expanded}>
              <FormControl variant="outlined">
                <InputLabel>Tem Params?</InputLabel>
                <Select
                  value={has_params}
                  onChange={(event) => setHasParams(event.target.value)}
                >
                  <MenuItem value>Sim</MenuItem>
                  <MenuItem value={false}>Não</MenuItem>
                </Select>
              </FormControl>
            </Collapse>
          </Grid>
          <Grid item xs={12}>
            <div align="right">
              <Button
                variant="contained"
                color="primary"
                onClick={handleSave}
                startIcon={<SaveIcon />}
              >
                Salvar
              </Button>
            </div>
          </Grid>
        </Grid>
      </Modal>

      <Modal
        className={classes.modal}
        open={openModalParams}
        onClose={() => setOpenModalParams(false)}
      >
        <Grid container spacing={1} className={classes.paper}>
          <Grid item xs={12}>
            <div align="center">
              <h2>Parametros</h2>
              <Typography variant="subtitle1" gutterBottom>
                Digite os Parametros para a Pesquisa
              </Typography>
            </div>
          </Grid>
          {labelParams.map((pr, i) => (
            <Grid item xs={6}>
              <TextField
                fullWidth
                id={pr}
                label={pr}
                variant="outlined"
                value={params[i]}
                onChange={(event) => {
                  const par = params;
                  par[i] = event.target.value;
                  setParams(par);
                }}
                helperText="Se for um campo de data preencha no formato YYYY-MM-DD.Exemplo:2021-02-18"
              />
            </Grid>
          ))}
          <Grid item xs={12}>
            <div align="right">
              <Button
                variant="contained"
                color="primary"
                onClick={handleParamsSave}
                startIcon={<SaveIcon />}
              >
                Salvar
              </Button>
            </div>
          </Grid>
        </Grid>
      </Modal>
    </>
  );
}

export default Faturamento;
